import { checkPIIAndFormatValues } from './checkPIIAndFormatValues';
import { keysToCamelCase } from './keysToCamelCase';
/**
 * Formats events in the determined case, and throws errors when PII data is submitted;
 */
export function checkAndFormatEvent(event) {
    return checkPIIAndFormatValues(keysToCamelCase(event));
}
